module.exports = __webpack_public_path__ + "static/img/express-icon.8ebb456b.svg";